import React, { useEffect, createElement } from 'react';
import { motion } from 'framer-motion';
import { BadgeCheckIcon, BookOpenCheckIcon, BriefcaseBusinessIcon, CalculatorIcon, CheckIcon, ClipboardListIcon, FilePenLineIcon, FileSpreadsheetIcon, GiftIcon, LandmarkIcon, MailIcon, NotebookTabsIcon, ReceiptTextIcon, ScaleIcon, SettingsIcon, ShieldCheckIcon, SparklesIcon, StarIcon, UsersRoundIcon, WalletCardsIcon } from 'lucide-react';
import { Accordion } from '../components/Accordion';
import { BonusCarousel } from '../components/BonusCarousel';
import { ContentCarousel } from '../components/ContentCarousel';
import { PurchaseButton } from '../components/PurchaseButton';
import { useScreenInit } from '../useScreenInit';
const HERO_IMAGE = 'https://cdn.magicpatterns.com/uploads/gwWndnMiDvNzDBgTXN7JDK/ChatGPT_Image_Jul_12,_2026,_04_51_44_AM.png';
const modules = [{
  title: 'Expediente Digital del Trabajador',
  description: 'Organiza la información esencial de cada persona trabajadora en una estructura clara y práctica.',
  icon: <NotebookTabsIcon size={20} data-id="element-44" data-mp="2zh40ry49gppx" />
}, {
  title: 'Control de Vacaciones y Prima Vacacional',
  description: 'Lleva el control de días, saldos y cálculos para dar seguimiento con mayor claridad.',
  icon: <WalletCardsIcon size={20} data-id="element-45" data-mp="3da201vjtr1yr" />
}, {
  title: 'Aguinaldo y PTU',
  description: 'Centraliza las referencias necesarias para revisar estas prestaciones con orden.',
  icon: <CalculatorIcon size={20} data-id="element-46" data-mp="3ibrg5plwm5tp" />
}, {
  title: 'Asistencia, Incidencias y Reforma de Jornada',
  description: 'Documenta incidencias y mantén un seguimiento operativo de la jornada.',
  icon: <ClipboardListIcon size={20} data-id="element-47" data-mp="3tifq2rt2os" />
}, {
  title: 'Altas, Bajas y Movimientos IMSS',
  description: 'Cuenta con una guía organizada para registrar movimientos y no perder pasos importantes.',
  icon: <FileSpreadsheetIcon size={20} data-id="element-48" data-mp="21uwt2fcnuh9c" />
}, {
  title: 'Calculadora de Finiquito e Indemnización',
  description: 'Una herramienta central para acompañar la revisión de cálculos y conceptos de salida.',
  icon: <ScaleIcon size={20} data-id="element-49" data-mp="307rdmdewaa6i" />
}, {
  title: 'Tracker de Onboarding y Offboarding',
  description: 'Da seguimiento a los pasos de ingreso y salida para una experiencia más ordenada.',
  icon: <UsersRoundIcon size={20} data-id="element-50" data-mp="397eb4o4i6vua" />
}];
const bonuses = [{
  title: 'BONO 1: Kit NOM-035 + Ley Silla listo para inspección',
  description: 'Material de apoyo para organizar documentación y revisar puntos relevantes antes de una inspección.',
  icon: <ShieldCheckIcon size={20} data-id="element-51" data-mp="ruoi7yc8bo7" />,
  previewImage: 'https://cdn.magicpatterns.com/uploads/7bPsGeCXtTyhDnwqqp7wzd/Bono_1.png',
  previewAlt: 'Vista previa del Bono 1'
}, {
  title: 'BONO 2: Guía de Incapacidades IMSS',
  description: 'Una guía de consulta para ubicar los pasos y referencias principales de incapacidades.',
  icon: <BookOpenCheckIcon size={20} data-id="element-52" data-mp="5s9ycpjev11f" />,
  previewImage: 'https://cdn.magicpatterns.com/uploads/x37PYv3ai7Pwg9kZsdAy9G/Bono_2.png',
  previewAlt: 'Vista previa del Bono 2'
}, {
  title: 'BONO 3: Checklist Onboarding/Offboarding PDF imprimible',
  description: 'Lista imprimible para no dejar pendientes en los procesos de ingreso y salida.',
  icon: <ClipboardListIcon size={20} data-id="element-53" data-mp="kd4ma3oa6yge" />,
  previewImage: 'https://cdn.magicpatterns.com/uploads/kizLwtjtdxFg3DA67Ga35F/Bono_3.png',
  previewAlt: 'Vista previa del Bono 3'
}, {
  title: 'BONO 4: 10 Plantillas Word editables (cartas, actas, constancias)',
  description: 'Plantillas editables para adaptar a los procesos internos de tu empresa.',
  icon: <FilePenLineIcon size={20} data-id="element-54" data-mp="3srmsdzunw3xd" />,
  previewImage: 'https://cdn.magicpatterns.com/uploads/buTMkZ7hM7XkfZyCZ9ntSd/Bono_4.png',
  previewAlt: 'Vista previa del Bono 4'
}, {
  title: 'BONO 5: Kit de Disciplina Progresiva (4 documentos Word)',
  description: 'Documentos para llevar un proceso disciplinario con un registro más consistente.',
  icon: <LandmarkIcon size={20} data-id="element-55" data-mp="3gqmyq3nce3hv" />,
  previewImage: 'https://cdn.magicpatterns.com/uploads/g9QWxYWdC39pZ18CAhc35E/Bono_5.png',
  previewAlt: 'Vista previa del Bono 5'
}, {
  title: 'BONO 6: Guía de contratación',
  description: 'Tipos de contratos y cuándo usarlos.',
  icon: <BookOpenCheckIcon size={20} data-id="element-56" data-mp="321ij8u7xmddg" />,
  previewImage: 'https://cdn.magicpatterns.com/patterns/generated-images/bb749b5a-bef9-4dc4-9313-34ed877ab5ac.jpg',
  previewAlt: 'Vista previa de la Guía de contratación'
}, {
  title: 'BONO 7: Checklist de cumplimientos NOM laborales',
  description: 'Checklist práctico para revisar los cumplimientos de NOM laborales.',
  icon: <ClipboardListIcon size={20} data-id="element-57" data-mp="2j4h96uzitn2n" />,
  previewImage: 'https://cdn.magicpatterns.com/patterns/generated-images/f7abaf55-d80a-4385-850e-822f06d6c438.jpg',
  previewAlt: 'Vista previa del Checklist de cumplimientos NOM laborales'
}, {
  title: 'BONO 8: Mini Guía de nómina para no contadores',
  description: 'Una guía breve para entender los conceptos clave de nómina.',
  icon: <ReceiptTextIcon size={20} data-id="element-58" data-mp="ttlqdk8fuppi" />,
  previewImage: 'https://cdn.magicpatterns.com/patterns/generated-images/2c2f7603-8277-49ff-89fe-974d9e0162f1.jpg',
  previewAlt: 'Vista previa de la Mini Guía de nómina'
}, {
  title: 'BONO 9: Tabla de cuotas IMSS',
  description: 'Tabla de consulta rápida para cuotas IMSS.',
  icon: <CalculatorIcon size={20} data-id="element-59" data-mp="6waemkj9pv5n" />,
  previewImage: 'https://cdn.magicpatterns.com/patterns/generated-images/199f99d3-902a-41a1-bb37-c77f4c308b30.jpg',
  previewAlt: 'Vista previa de la Tabla de cuotas IMSS'
}];
const objections = [{
  title: '¿El kit sustituye la asesoría legal o contable?',
  description: 'No. Es una herramienta de organización y consulta operativa. Para casos particulares o decisiones legales, consulta a la persona especialista correspondiente.',
  icon: <ScaleIcon size={19} data-id="element-60" data-mp="1wb8i6con3qay" />
}, {
  title: '¿Puedo usarlo si trabajo en una PyME?',
  description: 'Sí. El material está pensado para que los procesos cotidianos de RRHH sean más fáciles de organizar y dar seguimiento.',
  icon: <BriefcaseBusinessIcon size={19} data-id="element-61" data-mp="1gjpkdv3j6kuz" />
}, {
  title: '¿Cómo recibo el contenido?',
  description: 'Al completar la compra, el acceso y la entrega se gestionan desde la página de pago.',
  icon: <ReceiptTextIcon size={19} data-id="element-62" data-mp="ntpepu17h3r2" />
}];
type MetaPixelFunction = ((...args: unknown[]) => void) & {
  queue?: unknown[][];
  loaded?: boolean;
  version?: string;
};
function initializeMetaPixel() {
  const pixelWindow = window as Window & {
    fbq?: MetaPixelFunction;
  };
  if (pixelWindow.fbq?.loaded) {
    pixelWindow.fbq('track', 'PageView');
    return;
  }
  if (!pixelWindow.fbq) {
    const queue: unknown[][] = [];
    const pixelStub = ((...args: unknown[]) => {
      queue.push(args);
    }) as MetaPixelFunction;
    pixelStub.queue = queue;
    pixelStub.loaded = true;
    pixelStub.version = '2.0';
    pixelWindow.fbq = pixelStub;
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
  }
  pixelWindow.fbq('init', '1252242806993118');
  pixelWindow.fbq('track', 'PageView');
}
export function LandingPage() {
  useScreenInit();
  useEffect(() => {
    initializeMetaPixel();
  }, []);
  return <main className="site-shell" data-id="element-63" data-mp="2uk2ekaqhaotr">
      <section className="hero" aria-labelledby="hero-title" data-id="element-64" data-mp="2ugy794hpvcyv">
        <div className="hero-office" aria-hidden="true" data-id="element-65" data-mp="2zgj1x2pusz5s" />
        <div className="container hero-content" data-id="element-66" data-mp="2licob88c1vxk">
          <motion.h1 id="hero-title" initial={{
          opacity: 0,
          y: 14
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.45
        }} data-id="element-67" data-mp="2lhjjicsxpgi2">
            Reduce errores administrativos y riesgos laborales sin contratar
            consultores ni hacer cursos interminables.
          </motion.h1>

          <motion.a href="#oferta" className="product-link hero-product" aria-label="Ver la oferta del Kit RRHH en Orden" initial={{
          opacity: 0,
          scale: 0.97
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.5,
          delay: 0.12
        }} data-id="element-68" data-mp="20shlalso2msb">
            <img src={HERO_IMAGE} alt="Kit RRHH en Orden México 2026 con herramientas, documentos y beneficios para PyMEs" data-id="element-69" data-mp="2khs0lyoi35pw" />
          </motion.a>

          <p className="hero-subtitle" data-id="element-70" data-mp="2aqnn73eh3sx6">
            Todo lo que necesitas para gestionar personal en México
            correctamente — sin estudiar derecho laboral y sin depender del
            contador para cada duda.
          </p>

          <ul className="delivery-badges" aria-label="Características de entrega" data-id="element-71" data-mp="33dzwwczjc692">
            <li data-id="element-72" data-mp="3fptwyyvni1xf">
              <FilePenLineIcon size={17} aria-hidden="true" data-id="element-73" data-mp="3fpai5r1artnm" /> 100% PDF
            </li>
            <li data-id="element-74" data-mp="3koncewui0308">
              <SparklesIcon size={17} aria-hidden="true" data-id="element-75" data-mp="3ko3uhg4ulem7" /> Entrega Inmediata
            </li>
            <li data-id="element-76" data-mp="3or0gzhxiduvf">
              <BookOpenCheckIcon size={17} aria-hidden="true" data-id="element-77" data-mp="3orjos5tg32vq" /> 7 herramientas
              funcionales + 9 bonos
            </li>
          </ul>
          <PurchaseButton data-id="element-78" data-mp="2jk5r7ovvixp" />
          <p className="secure-note" data-id="element-79" data-mp="2is8lsfn1d5b">
            <ShieldCheckIcon size={15} aria-hidden="true" data-id="element-80" data-mp="2hpivnu1xgqz" /> Acceso mediante
            página de pago segura
          </p>
        </div>
      </section>

      <section className="section pain-section" aria-labelledby="pain-title" data-id="element-81" data-mp="c9v7cnl3hg1f">
        <div className="container narrow" data-id="element-82" data-mp="gaypxhuj1q6c">
          <p className="section-kicker" data-id="element-83" data-mp="gc03pu2xgqrr">Tu día a día</p>
          <h2 id="pain-title" data-id="element-84" data-mp="la1ku9gsmg0l">
            El problema no es trabajar en RRHH, es resolver todo sola
          </h2>
          <div className="pain-list" data-id="element-85" data-mp="1g7qeckrfs18n">
            {['Tener que buscar la respuesta correcta mientras el equipo espera una solución.', 'Llevar vacaciones, incidencias y expedientes en archivos que no conversan entre sí.', 'Dudar qué documento usar para cada movimiento, carta o situación con el personal.', 'Sentir presión por cumplir procesos sin contar con una ruta clara para ordenarlos.', 'Invertir horas en tareas repetitivas que podrían tener una estructura desde el inicio.'].map((pain, index) => <article className="pain-card" key={pain} data-id="element-86" data-mp="28w5ha8xamt3m" data-mpi={index}>
                <span className="pain-number" data-id="element-87" data-mp="28wni7iuwhvhv">0{index + 1}</span>
                <p data-id="element-88" data-mp="2dtxhrrc07njf">{pain}</p>
              </article>)}
          </div>
        </div>
      </section>

      <section className="section modules-section" aria-labelledby="modules-title" data-id="element-89" data-mp="ej64soo7mf0k">
        <div className="container narrow" data-id="element-90" data-mp="jhhf10if2rjb">
          <p className="section-kicker" data-id="element-91" data-mp="2wr7fmpwbei4s">Una base para tu operación</p>
          <h2 id="modules-title" data-id="element-92" data-mp="2wsilqwd8g1z2">Para eso hicimos este kit</h2>
          <p className="section-intro" data-id="element-93" data-mp="2rzfy14v4zmqs">
            Herramientas pensadas para acompañar las tareas que más se repiten
            en tu área.
          </p>
          <Accordion items={modules} data-id="element-94" data-mp="2izsvugul2cwo" />
          <div className="center-action" data-id="element-95" data-mp="2j0vlklg669b0">
            <PurchaseButton data-id="element-96" data-mp="2ixpx98fd7bgc" />
          </div>
        </div>
      </section>

      <section className="section feedback-section" aria-labelledby="feedback-title" data-id="element-97" data-mp="3fos2jrfir6mr">
        <div className="container narrow" data-id="element-98" data-mp="3bp9kr4izvbo5">
          <h2 className="feedback-heading" id="feedback-title" data-id="element-99" data-mp="36p549ei36gxx">
            Opiniones de quienes ya se organizaron
          </h2>
          <div className="feedback-grid" data-id="element-100" data-mp="31p8zve5h8nhu">
            {[['“Con las plantillas de constancias dejé de perder tiempo buscando formatos. Ahora solo ajusto los datos y las tengo listas mucho más rápido.”', 'Mariana G. · Coordinadora de RRHH · Guadalajara, Jalisco'], ['“El checklist de onboarding me ayudó a ordenar las altas nuevas. Ya no se me van pendientes como accesos, documentos o inducción.”', 'Luis R. · Generalista de talento · Monterrey, Nuevo León'], ['“La herramienta de vacaciones me resolvió el control de saldos. Por fin puedo responderle al equipo con claridad y sin hacer cuentas a mano.”', 'Karla M. · Encargada administrativa · Ciudad de México']].map(([quote, role]) => <figure className="feedback-card" key={quote} data-id="element-101" data-mp="102639w29qmxx">
                <div className="feedback-rating" aria-label="Calificación de 5 de 5 estrellas" data-id="element-102" data-mp="142q0t0qr7skl">
                  {Array.from({
                length: 5
              }, (_, index) => <StarIcon key={index} size={15} fill="currentColor" aria-hidden="true" data-id="element-103" data-mp="q3gucsscoctt" />)}
                </div>
                <div className="quote-mark" aria-hidden="true" data-id="element-104" data-mp="bg9srdor8r7l">
                  “
                </div>
                <blockquote data-id="element-105" data-mp="6h6ovwkigr17">{quote}</blockquote>
                <figcaption data-id="element-106" data-mp="6igk8dzzbl45">{role}</figcaption>
              </figure>)}
          </div>
          <p className="content-preview-title" data-id="element-107" data-mp="lf7cm3b8jwk9">Echale un vistazo al contenido</p>
          <ContentCarousel images={[{
          src: 'https://cdn.magicpatterns.com/uploads/3zPNb5ww7W5FRSgYYGw1fv/Screenshot_2026-07-17_at_4.58.40_PM.png',
          alt: 'Vista previa del expediente digital del trabajador'
        }, {
          src: 'https://cdn.magicpatterns.com/uploads/x7agJBjcPBT8TWRuitM6dN/Screenshot_2026-07-17_at_4.59.11_PM.png',
          alt: 'Vista previa de la tabla de vacaciones dignas'
        }, {
          src: 'https://cdn.magicpatterns.com/uploads/6xd9xBabWBrhQhg3E1EJ5J/Screenshot_2026-07-17_at_4.59.53_PM.png',
          alt: 'Vista previa del control de aguinaldo'
        }, {
          src: 'https://cdn.magicpatterns.com/uploads/2icCaPa8DMQW7DqoK3LZy3/Screenshot_2026-07-17_at_5.00.13_PM.png',
          alt: 'Vista previa del control de asistencia e incidencias'
        }, {
          src: 'https://cdn.magicpatterns.com/uploads/9kkECtrt8L89E3Rf2j9Y1a/Screenshot_2026-07-17_at_5.00.29_PM.png',
          alt: 'Vista previa de la tabla de cuotas IMSS 2026'
        }]} data-id="element-108" data-mp="gf33iycnq442" />
        </div>
      </section>

      <section className="section bonus-section" aria-labelledby="bonus-title" data-id="element-109" data-mp="2op2e8535geln">
        <div className="container narrow" data-id="element-110" data-mp="2tkre69j2zxih">
          <p className="section-kicker" data-id="element-111" data-mp="2xnecmta9cgon">Material complementario</p>
          <h2 id="bonus-title" data-id="element-112" data-mp="2xljn11o1k0e8">Además incluido con tu kit</h2>
          <p className="bonus-note" data-id="element-113" data-mp="8usbaegw8emq">
            <GiftIcon size={17} aria-hidden="true" data-id="element-114" data-mp="8xwjro1e5wj7" /> Los bonos se incluyen sin
            costo adicional con la compra del Kit.
          </p>
          <BonusCarousel bonuses={bonuses} data-id="element-115" data-mp="1xfzi4c6scqz8" />
        </div>
      </section>

      <section className="section comparison-section" aria-labelledby="comparison-title" data-id="element-116" data-mp="1tdumj7ws1k9y">
        <div className="container narrow" data-id="element-117" data-mp="1omw33zghs62h">
          <p className="section-kicker" data-id="element-118" data-mp="1oll40cxzrmhp">Un cambio tangible</p>
          <h2 id="comparison-title" data-id="element-119" data-mp="1jokx5ztbifpj">
            Sin Kit RRHH en Orden vs Con Kit RRHH en Orden
          </h2>
          <div className="comparison-table" role="table" aria-label="Comparación del flujo de trabajo" data-id="element-120" data-mp="1ep87l7b2auj9">
            <div className="comparison-column comparison-column--without" role="rowgroup" data-id="element-121" data-mp="19s84n59ie7wd">
              <h3 role="columnheader" data-id="element-122" data-mp="10pqe4emtmt3k">Sin Kit RRHH en Orden</h3>
              <ul data-id="element-123" data-mp="10rjoo50k1xgu">
                <li data-id="element-124" data-mp="3021avhvhcusy">Buscar formatos cada vez</li>
                <li data-id="element-125" data-mp="301sx7nrj9lgp">Procesos dispersos</li>
                <li data-id="element-126" data-mp="2v3856bmfq83c">Más tiempo resolviendo dudas</li>
                <li data-id="element-127" data-mp="2v3re52u3xm58">Seguimiento manual de pendientes</li>
              </ul>
            </div>
            <div className="comparison-column comparison-column--with" role="rowgroup" data-id="element-128" data-mp="3e71lj86293fq">
              <h3 role="columnheader" data-id="element-129" data-mp="3j0o23bfchrgt">Con Kit RRHH en Orden</h3>
              <ul data-id="element-130" data-mp="3587wc2v27fc7">
                <li data-id="element-131" data-mp="358zpl716p0zb">Material organizado para consultar</li>
                <li data-id="element-132" data-mp="3a5gcxz0k7bbc">Herramientas en un solo lugar</li>
                <li data-id="element-133" data-mp="3a45aq3mribmc">Mayor claridad para priorizar</li>
                <li data-id="element-134" data-mp="1rhij1t8jxzy">Checklists para dar seguimiento</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="offer-section" id="oferta" aria-labelledby="offer-title" data-id="element-135" data-mp="5r8edjxmd4bc">
        <div className="container offer-container" data-id="element-136" data-mp="3o00l1l33iee4">
          <div className="offer-heading" data-id="element-137" data-mp="3svodc9cvjnnu">
            <p className="eyebrow" data-id="element-138" data-mp="3syka3uczk6ap">
              <span data-id="element-139" data-mp="2chy30kv5w35r" /> Kit digital para tu operación
            </p>
            <h2 id="offer-title" data-id="element-140" data-mp="2cku2weqkl1wu">Pon orden en tu área de RRHH</h2>
            <p data-id="element-141" data-mp="2hj5ccocydaej">
              Una compra, un solo lugar para organizar herramientas, documentos
              y procesos cotidianos.
            </p>
          </div>
          <div className="offer-card" data-id="element-142" data-mp="24zhxnku8cfv5">
            <div className="offer-card-top" data-id="element-143" data-mp="24yovyya4ogjv">
              <div data-id="element-144" data-mp="2iyhiehemgam1">
                <p className="summary-label" data-id="element-145" data-mp="2iyzl9wvshn2x">Resumen de tu pedido</p>
                <h3 data-id="element-146" data-mp="2dzmzlfgnmm1x">Kit RRHH en Orden</h3>
                <p className="summary-items" data-id="element-147" data-mp="2e0y6ho5ec9x9">
                  20+ herramientas y recursos para organizar tu operación
                </p>
              </div>
              <BadgeCheckIcon size={30} aria-hidden="true" data-id="element-148" data-mp="1m8qoaja8spgr" />
            </div>
            <ul className="order-summary-grid" aria-label="Contenido incluido en el kit" data-id="element-149" data-mp="1m6noj7jafhyu">
              <li data-id="element-150" data-mp="1v8n5jzuaym1s">
                <CheckIcon size={15} aria-hidden="true" data-id="element-151" data-mp="1v83zbge0lm3l" />
                <span data-id="element-152" data-mp="17jkqmzr1z7az">
                  <strong data-id="element-153" data-mp="17j2ppptg44wq">7</strong> herramientas Excel funcionales
                </span>
              </li>
              <li data-id="element-154" data-mp="12l9h6q4o6yta">
                <CheckIcon size={15} aria-hidden="true" data-id="element-155" data-mp="12jpy6rrmq9nt" />
                <span data-id="element-156" data-mp="hyxqbd0agwkc">
                  <strong data-id="element-157" data-mp="hzpngs9jb2cq">4</strong> PDFs informativos
                </span>
              </li>
              <li data-id="element-158" data-mp="lzhp0l0ig88l">
                <CheckIcon size={15} aria-hidden="true" data-id="element-159" data-mp="m116gexwkpby" />
                <span data-id="element-160" data-mp="qzm3k5huysw6">
                  <strong data-id="element-161" data-mp="qyb0k7w8lp64">10</strong> plantillas Word editables
                </span>
              </li>
              <li data-id="element-162" data-mp="vzgta5pwdcfn">
                <CheckIcon size={15} aria-hidden="true" data-id="element-163" data-mp="w00djt30scwu" />
                <span data-id="element-164" data-mp="10y1xshc6mi9w">
                  <strong data-id="element-165" data-mp="10wqt8fawx6hq">4</strong> documentos de disciplina progresiva
                </span>
              </li>
              <li data-id="element-166" data-mp="14xkj3e7x0vd9">
                <CheckIcon size={15} aria-hidden="true" data-id="element-167" data-mp="14x0whk7blisw" />
                <span data-id="element-168" data-mp="19qvgkoqu7zsi">Recursos de onboarding y offboarding</span>
              </li>
            </ul>
            <div className="price-row" data-id="element-169" data-mp="1envn10rln4k5">
              <div data-id="element-170" data-mp="1er19074xlqbn">
                <span className="old-price" data-id="element-171" data-mp="1jo00sj14hl6o">
                  $871 MXN <small data-id="element-172" data-mp="1jpl0en2anube">(50 USD)</small>
                </span>
                <strong data-id="element-173" data-mp="1oml26ls42awp">
                  $300 <small data-id="element-174" data-mp="1onmh51c8zhjp">MXN (17 USD)</small>
                </strong>
              </div>
              <span className="one-time" data-id="element-175" data-mp="3966tsrhzxwvu">Pago único</span>
            </div>
            <PurchaseButton className="purchase-button--wide" label="Quiero mi kit RRHH ahora" data-id="element-176" data-mp="345j0u0a7j5yz" />
            <p className="payment-note" data-id="element-177" data-mp="2z7hijhklvaok">
              <CheckIcon size={15} aria-hidden="true" data-id="element-178" data-mp="2u7wa8gjjppz6" /> Un solo pago para
              acceder a todo el paquete detallado arriba.
            </p>
          </div>
        </div>
      </section>

      <section className="section faq-section" aria-labelledby="faq-title" data-id="element-179" data-mp="3rxhid2091xkk">
        <div className="container narrow" data-id="element-180" data-mp="3mxbt1shgcn5n">
          <p className="section-kicker" data-id="element-181" data-mp="3i5bofmqft62q">Antes de decidir</p>
          <h2 id="faq-title" data-id="element-182" data-mp="3i3qunzby5r5x">Preguntas frecuentes</h2>
          <Accordion items={objections} data-id="element-183" data-mp="3d7ij0vwykg3i" />
        </div>
      </section>

      <footer className="footer" data-id="element-184" data-mp="egqkgcsqfw32">
        <div className="container footer-content" data-id="element-185" data-mp="ehs435ntdqwe">
          <div className="support-mark" aria-hidden="true" data-id="element-186" data-mp="eil13ewz121c">
            <SettingsIcon size={25} data-id="element-187" data-mp="9ogw3179n42w" />
            <MailIcon size={12} data-id="element-188" data-mp="9o779gxyj2ys" />
          </div>
          <div data-id="element-189" data-mp="20bxcg9t7pc2i">
            <p data-id="element-190" data-mp="20cfdrkuqegha">Soporte</p>
            <a href="mailto:EbookDreamShop@gmail.com" data-id="element-191" data-mp="208htux0bxkwc">
              EbookDreamShop@gmail.com
            </a>
          </div>
        </div>
      </footer>
    </main>;
}